import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
// Lazy-load secondary pages so the homepage ships less JS
const AboutPage = lazy(() => import('./pages/AboutPage').then(m => ({
  default: m.AboutPage
})));
const ProgramsPage = lazy(() => import('./pages/ProgramsPage').then(m => ({
  default: m.ProgramsPage
})));
const ImpactPage = lazy(() => import('./pages/ImpactPage').then(m => ({
  default: m.ImpactPage
})));
const ArticlesPage = lazy(() => import('./pages/ArticlesPage').then(m => ({
  default: m.ArticlesPage
})));
const ArticleDetailPage = lazy(() => import('./pages/ArticleDetailPage').then(m => ({
  default: m.ArticleDetailPage
})));
const TestimonyDetailPage = lazy(() => import('./pages/TestimonyDetailPage').then(m => ({
  default: m.TestimonyDetailPage
})));
const TeamPage = lazy(() => import('./pages/TeamPage').then(m => ({
  default: m.TeamPage
})));
const JourneyPage = lazy(() => import('./pages/JourneyPage').then(m => ({
  default: m.JourneyPage
})));
const GalleryPage = lazy(() => import('./pages/GalleryPage').then(m => ({
  default: m.GalleryPage
})));
const JoinPage = lazy(() => import('./pages/JoinPage').then(m => ({
  default: m.JoinPage
})));
function PageFallback() {
  return <div className="min-h-[60vh] flex items-center justify-center pt-20" data-id="element-0" data-mp="33ori60dy9voz">
      <div className="w-8 h-8 border-2 border-gold/30 border-t-gold rounded-full animate-spin" data-id="element-1" data-mp="38l06o4e1f18t" />
    </div>;
}
export function App() {
  return <Router data-id="element-2" data-mp="nvj2rdpwcaoo">
      <ScrollToTop data-id="element-3" data-mp="nvssd0714ftu" />
      <div className="min-h-screen flex flex-col w-full" data-id="element-4" data-mp="nuhged3fk1rn">
        <Navigation data-id="element-5" data-mp="sunby4ctm8f0" />
        <Suspense fallback={<PageFallback data-id="element-7" data-mp="stko65asom3b" />} data-id="element-6" data-mp="su445ggvx0ep">
          <Routes data-id="element-8" data-mp="sssr0q1jugax">
            <Route path="/" element={<Home data-id="element-10" data-mp="3688rpx40wyp" />} data-id="element-9" data-mp="swgmhuqk1csa" />
            <Route path="/about" element={<AboutPage data-id="element-12" data-mp="34nbvtnbp1xo" />} data-id="element-11" data-mp="35gmj5pekbl3" />
            <Route path="/programs" element={<ProgramsPage data-id="element-14" data-mp="3udkmtw2p4uae" />} data-id="element-13" data-mp="3uct25gan0gyw" />
            <Route path="/impact" element={<ImpactPage data-id="element-16" data-mp="d4nx5l4r5s4i" />} data-id="element-15" data-mp="3ucjc5sple9t7" />
            <Route path="/team" element={<TeamPage data-id="element-18" data-mp="d45rxz0443kg" />} data-id="element-17" data-mp="d4xobc1ja5bs" />
            <Route path="/journey" element={<JourneyPage data-id="element-20" data-mp="851l3f0nuhxa" />} data-id="element-19" data-mp="d2bibguajxvo" />
            <Route path="/gallery" element={<GalleryPage data-id="element-22" data-mp="83i0xdbvvmq8" />} data-id="element-21" data-mp="86w58r43y60b" />
            <Route path="/join" element={<JoinPage data-id="element-24" data-mp="3gmfuzg5kl6am" />} data-id="element-23" data-mp="3gl4pnbwh7qhe" />
            <Route path="/articles" element={<ArticlesPage data-id="element-26" data-mp="3bmbazg5gdtfn" />} data-id="element-25" data-mp="3glnym345f4ja" />
            <Route path="/articles/:slug" element={<ArticleDetailPage data-id="element-28" data-mp="3bk702e94zu5v" />} data-id="element-27" data-mp="3bncqbwti5236" />
            <Route path="/testimonies/:slug" element={<TestimonyDetailPage data-id="element-30" data-mp="3qdafog363xty" />} data-id="element-29" data-mp="3qaxuzv60z9d7" />
          </Routes>
        </Suspense>
        <Footer data-id="element-31" data-mp="3lj6bg4lae3wk" />
      </div>
    </Router>;
}